import React, { useEffect, useState } from "react";
import { Search, ShoppingCart, Download, Pencil } from "lucide-react";
// import { toast } from "react-toastify";
import { useProductStore } from "../../store/useProductStore";
import { useAuthStore } from "../../store/useAuthStore";
import { Pagination, Stack } from "@mui/material";
import Loader from "../../components/Loader/Loader";
import Datepicker from "react-tailwindcss-datepicker";
import moment from "moment";
import { useDistributorStore } from "../../store/useDistributorStore";
import { usePackerDispatcher } from "../../store/usePackerDispatcher";
import AddPackerDispatcherPopup from "../../components/Model/AddPackerDispatcherPopup";

const zoneOptions = [
  {value : 1, label : 'North'},
  {value : 2, label : 'East'},
  {value : 3, label : 'West'},
  {value : 4, label : 'South'},
];

const PackerDispatcher = () => {
    const { user } = useAuthStore();
    const USER_ROLE = user?.userDataObj?.role;
    const { fetchProducts, setCartCount, fetchSkuMakeandSegment } = useProductStore();
    const [operators,setOperators] = useState([])
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [totalCount, setTotalCount] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [states,setStates] = useState([])
    const [districts,setDistricts] = useState([])
    const [editData,setEditData] = useState({})
    const [showAddModel,setShowAddModel] = useState(false)
    const [tabData,setTabData] = useState({})
    // const edit
    const [filter, setFilter] = useState({
        limit: 10,
        offset: 1,
        state_id: [],
        district_id: [],
        region_id: [],
        nameOrNumber: '',
        order_id: undefined,
        block_user: '',
        role_id: undefined
    })

    const [value, setValue] = useState(null);
    const [isOpen, setIsOpen] = useState(false);

    const handleToggle = () => setIsOpen((prev) => !prev);

    const [isLoading, setIsLoading] = useState(false);

    const [make, setMake] = useState([])
    const [size, setSize] = useState([])
    const [segment, setSegment] = useState([])

    const {fetchStatesList,fetchDistrictsList} = useDistributorStore();
    const { fetchPackerDispatchers } = usePackerDispatcher();
    // const { fetchSummary,fetchAdminSummary } = useSummaryStore();

    // Get cart data from localStorage (product_data)
    const getCartData = () => {
        return JSON.parse(localStorage.getItem("product_data")) || [];
    };

    const fetchData = async (filter) => {
      // console.log(fetchData, 'fetchData')
      console.log(filter, 'filter fetchData')
        setIsLoading(true);

        const res =  await fetchPackerDispatchers(filter);

        if(res?.status === true) {
          setTotalPages(res.data.pagination.totalPages);
          setTotalCount(res.data.count);
          setOperators(res?.data?.distributorList)
        } else {
          setTotalPages(1);
          setTotalCount(0);
          setOperators([]);
        }

        setIsLoading(false);
    };

    const fetchSkuMakeandSegmentData = async () => {
        const res = await fetchSkuMakeandSegment();

        if (res.status) {
            const { make, segment, size } = res.data;
            setMake(make);
            setSegment(segment);
            setSize(size);
        } else {
            setMake([]);
            setSegment([]);
            setSize([]);
        }

    };

    // State to manage cart data
    const [cartData, setCartData] = useState(getCartData());

    useEffect(() => {
        // Update cart count whenever cartData changes
        setCartCount(cartData.filter(value => value?.ordered_quantity > 0).length);
    }, [cartData, setCartCount]);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
        setFilter({ ...filter, offset: pageNumber })
    };

    const fetchStates = async () => {
      // setIsLoading(true)
      const res = await fetchStatesList()

      if(res.status) {
        setStates(res.data)
      }
    }

    const fetchDistricts = async (state_id) => {
      let params = {state_id : state_id}
      const res = await fetchDistrictsList(params)

      if(res.status) {
        setDistricts(res.data)
      }
    }

    const handleSearch = () => {
      setCurrentPage(1);

      console.log(value)
  
      setFilter((prevFilter) => {
          const updatedFilter = { 
              ...prevFilter, 
              offset: 1
          };
            if(value) {
              updatedFilter.start_date = new moment(value?.startDate)?.format('YYYY-MM-DD');
              updatedFilter.end_date = new moment(value?.endDate)?.format('YYYY-MM-DD');
            }
  
          fetchData(updatedFilter);
          return updatedFilter;
      });
  };

  const onClose = () => {
    setEditData({})
    setShowAddModel(false)
  }

    const handleReset = () => {
        setFilter({
          limit: 10,
          offset: 1,
          state_id: [],
          district_id: [],
          status_id: undefined,
          region_id: [],
          distrNameOrNumber: '',
          order_id: undefined,
        })
        setValue(null,null)
        setCurrentPage(1)
        fetchData({ limit: 10, offset: 1});
    }

    useEffect(() => {
      fetchStates()
    }, []);

    useEffect(() => {
      if(filter.state_id) fetchDistricts(filter.state_id)
    }, [filter.state_id]);

    useEffect(() => {
        fetchData(filter);
    }, [currentPage]);

    useEffect(() => {
        fetchSkuMakeandSegmentData();
    }, []);

    useEffect(() => {
      handleSearch();
  }, [filter.role_id, filter.block_user])

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSearch(); 
    }
  };

      if(isLoading){
        return <Loader />
      }

    return (
      <>
        <div className="overflow-x-auto">
         <div className="flex justify-end mb-3 mt-2 mr-1">
         <button
              onClick={() => setShowAddModel(true)}
              className="inline-flex items-center px-3 py-1.5 text-sm font-medium text-emerald-600 bg-emerald-100 rounded-md hover:bg-emerald-200 focus:outline-none focus:ring-2 focus:ring-emerald-500"
            >
              Add Member
            </button>
          </div>
          <div className="flex flex-col md:flex-row items-center mb-4 space-y-2 md:space-y-0 md:space-x-4">
            <div className="flex flex-col md:flex-column md:items-center gap-2 w-full">
              <div className="grid grid-cols-1 md:flex md:space-x-2 w-full gap-1 custom-grid">
                  <div className={`relative basis-[25%] w-full ${USER_ROLE === 4 ? 'md:w-[425px]' : 'md:w-[350px]' }`}>
                  <Search className="absolute left-1 top-2 h-5 w-5 text-gray-400" />
                  <input
                    type="text"
                    value={filter.nameOrNumber}
                    onKeyDown={handleKeyDown}
                    onChange={(e) => setFilter({ ...filter, nameOrNumber: e.target.value })}
                    placeholder="Search by Packer name/Number"
                    className="w-full pl-8 pr-1 py-1 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary"
                  />
                </div>

                    {/* <select className="border basis-[10%] border-gray-300 rounded-lg px-2 py-1 w-full md:w-auto" value={filter?.region_id?.length ? filter.region_id[filter.region_id.length - 1] : ""}
                        onChange={(e) => {
                          const selectedValue = e.target.value;
    
                          setFilter((prevFilter) => {
                            const currentStatus = prevFilter.region_id || [];
    
                            const updatedStatusId = selectedValue ? currentStatus.includes(selectedValue)
                            ? currentStatus
                            : [Number(selectedValue)] : undefined;
    
                            return { ...prevFilter, region_id: updatedStatusId };
                          });
                        }}>
                  <option value="">All Zone</option>
                                {
                                    zoneOptions.map((val,i) => {
                                        return <option key={val.value} value={val.value}>{val.label}</option>
                                    })
                                }
                </select> */}

                <select className="border basis-[10%] border-gray-300 rounded-lg px-2 py-1 w-full md:w-[230px]" value={filter.role_id}
                                onChange={(e) => setFilter({ ...filter, role_id: e.target.value ? [Number(e.target.value)] : undefined })}>
                  <option value="">All Role</option>
                  {/* <option value="-1">All Role</option> */}
                  <option value={1}>Packer</option>              
                  <option value={2}>Dispatcher</option>              
                </select>
                {/* <select className="border basis-[10%] border-gray-300 rounded-lg px-2 py-1 w-full md:w-[230px]" value={filter.state_id}
                                onChange={(e) => setFilter({ ...filter, state_id: e.target.value ? [Number(e.target.value)] : undefined })}>
                  <option value="">All State</option>
                                {
                                    states.map((state) => {
                                      return <option key={state.state_id} value={state.state_id}>{state.state_name}</option>
                                    })
                                }
                </select>
                <select className="border basis-[10%] border-gray-300 rounded-lg px-2 py-1 w-full md:w-[230px]"
                  value={filter.district_id} disabled={!filter.state_id || filter.state_id.length === 0}
                                onChange={(e) => setFilter({ ...filter, district_id: e.target.value ? [Number(e.target.value)] : undefined })}>
                  <option value="">All District</option>
                                {
                                    districts?.map((district) => {
                                        return <option key={district?.id} value={district.id}>{district?.name}</option>
                                    })
                                }

                </select> */}
                <select className="border basis-[10%] border-gray-300 rounded-lg px-2 py-1 w-full md:w-[230px]" value={filter.block_user}
                                onChange={(e) => setFilter({ ...filter, block_user: e.target.value ? [Number(e.target.value)] : undefined })}>
                                <option value="">All Status</option>
                                {/* <option value="-1">All Status</option> */}
                                <option value={0}>Active</option>              
                                <option value={1}>Blocked</option>              
                </select>
                {/* <button className="w-full block md:w-auto px-2 py-1 bg-emerald-500 text-white text-sm rounded hover:bg-emerald-600 transition" onClick={handleSearch}>
                Apply
              </button> */}

              <button
                            className="w-full md:w-auto px-2 py-1 border-2 text-black rounded-lg transition" onClick={handleReset}>
                Reset
              </button>
              </div>     
            </div>
          </div>

          <div className="overflow-auto h-[250px] sm:h-[400px] md:h-[450px] xl:h-[600px] rounded-lg">
            <table className="min-w-full overflow-auto divide-y divide-gray-200">
              <thead>
                <tr className="bg-emerald-200">
                 <th className="p-3 text-left text-sm font-bold text-gray-700 ">
                    First Name
                  </th>
                 <th className="p-3 text-left text-sm font-bold text-gray-700 ">
                    Last Name
                  </th>
                 <th className="p-3 text-left text-sm font-bold text-gray-700 ">
                    Mobile
                  </th>
                 <th className="p-3 text-left text-sm font-bold text-gray-700 ">
                    Role
                  </th>
                 <th className="p-3 text-left text-sm font-bold text-gray-700 ">
                    Status
                  </th>
                {
                  USER_ROLE === 4 && 
                    <th className="p-3 text-left text-sm font-bold text-gray-700">
                      Edit
                    </th>
                }
                </tr>
              </thead>
              {operators.length !== 0 ? (
                        <tbody className="bg-white divide-y divide-gray-200">
                          {operators.map((data, index) => (
                            <tr key={data?.order_id} className="bg-white">
                              <td className="p-3 whitespace-nowrap text-sm text-gray-800 text-left">
                                {data?.firstName || ""}
                              </td>
                              <td className="p-3 whitespace-nowrap text-sm text-gray-800 text-left">
                                {data?.lastName || ""}
                              </td>
                              <td className="p-3 whitespace-nowrap text-sm text-gray-800 text-left">
                                {data?.mobile ?? 'NA'}
                              </td>
                              <td className="p-3 whitespace-nowrap text-sm text-gray-800 text-left">
                                {data?.role === 1 ? 'Packer' : 'Dispatcher'}
                              </td>
                              <td className="p-3 whitespace-nowrap text-sm text-gray-800 text-left">
                                {data?.block_user === "0" ? "ACTIVE" : "BLOCKED"}
                              </td>

                              {USER_ROLE === 4 && (
                                  <td className="p-3 whitespace-nowrap text-sm text-gray-800 text-left" onClick={() => {
                                    setEditData({
                                      user_id: data?.user_id,
                                      firstName: data?.firstName,
                                      lastName: data?.lastName,
                                      mobile: data?.mobile,
                                      role: data?.role,
                                      block_user: data?.block_user
                                    })
                                    setShowAddModel(true)
                                  }} >
                                    {<Pencil size={16} className="cursor-pointer flex justify-center items-center" />}
                                  </td>
                              )}
                            </tr>
                          ))}
                        </tbody>
                      ) : (
                        <tbody>
                          <tr>
                            <td className="p-3 whitespace-nowrap text-sm text-center text-gray-900" colSpan={10}>
                              No Packer Dispatcher Found
                            </td>
                          </tr>
                        </tbody>
                      )}
            </table>

            {totalCount !== null && (
            <div className="flex justify-center mt-2">
              <Stack spacing={2}>
                <Pagination
                  count={totalPages}
                  page={currentPage}
                  onChange={(event, value) => handlePageChange(value)}
                  variant="outlined"
                  shape="rounded"
                  color="primary"
                  size="10"
                />
              </Stack>
            </div>
          )}
          </div>
        </div>
        {
          showAddModel && <AddPackerDispatcherPopup onClose={onClose} fetchData={fetchData} filter={filter} editData={editData} setEditData={setEditData} setCurrentPage={setCurrentPage} />
        }

        {/* {isModalOpen && (
          <ProductModal
            closeModal={() => setIsModalOpen(false)}
            Close
            modal
            function
          />
        )} */}
      </>
    );
};

export default PackerDispatcher;